import { PurposeEnum } from "@/types/types";
import { useEdittingStore } from "../context/useEdittingStore";
import styles from "./purpose-switcher.module.css";
import SwitcherChild from "./switcher-child";

export default function PurposeSwitcher({
  forSalePlaceholder,
  forRentPlaceholder,
}: {
  forSalePlaceholder: string;
  forRentPlaceholder: string;
}) {
  const purpose = useEdittingStore((state) => state.listing.purpose);
  const setField = useEdittingStore((state) => state.setField);
  return (
    <div id="purpose" className={styles.switcherWrapper}>
      <SwitcherChild
        text={forSalePlaceholder}
        isActive={purpose === PurposeEnum.FORSALE}
        onClick={() => setField("purpose", PurposeEnum.FORSALE)}
      />
      <SwitcherChild
        text={forRentPlaceholder}
        isActive={purpose === PurposeEnum.FORRENT}
        onClick={() => setField("purpose", PurposeEnum.FORRENT)}
      />
    </div>
  );
}
